var _excluded = ["domain", "price", "button", "label", "images", "icon", "subtext", "subtextTooltip", "caption", "hasSuccess", "hasError", "errorMessage", "isDisabled", "disabledMessage", "isLoading", "hasHiddenLoader", "additionalBox", "customButton", "hasImagesAndLabelBottomOnMobile"],
  _excluded2 = ["text", "title"],
  _excluded3 = ["tooltip"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { isValidElement } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import useBreakpoint from "../../../hooks/useBreakpoint";
var CartAdd = function CartAdd(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.979 10.396c0-.95-.562-1.766-1.366-2.153l1.328-3.98-1.515-.506L13.009 8H5.42L3.017.021H.021v1.596H1.83l2.404 7.979h9.35c.438 0 .8.357.8.8 0 .438-.358.8-.8.8H3.212v1.595h.945c-.09.252-.15.515-.15.8a2.398 2.398 0 0 0 2.396 2.396A2.398 2.398 0 0 0 8.8 13.591c0-.28-.06-.548-.149-.8h1.094c-.09.252-.149.515-.149.8a2.398 2.398 0 0 0 2.396 2.396 2.398 2.398 0 0 0 2.395-2.396c0-.314-.063-.612-.174-.889 1.013-.285 1.766-1.204 1.766-2.306Zm-8.775 3.191c0 .438-.357.8-.8.8a.802.802 0 0 1-.8-.8c0-.438.358-.8.8-.8.439 0 .8.358.8.8Zm4.788.796a.802.802 0 0 1-.8-.8c0-.438.357-.8.8-.8.438 0 .8.357.8.8a.805.805 0 0 1-.8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 0H8.5v2h-2v1.5h2v2H10v-2h2V2h-2V0Z"
  }));
};
CartAdd.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LineRotateRight = function LineRotateRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 1.25a.75.75 0 0 0-.75.75v1.496a8.803 8.803 0 0 0-.275-.234C11.881 2.365 10.22 1.453 8 1.453c-3.737 0-6.75 2.966-6.75 6.649 0 3.684 3.034 6.648 6.75 6.648s6.75-2.964 6.75-6.648a.75.75 0 0 0-1.5 0c0 2.831-2.338 5.148-5.25 5.148s-5.25-2.317-5.25-5.148c0-2.833 2.32-5.149 5.25-5.149 1.781 0 3.119.727 4.025 1.469.126.103.243.207.352.308h-1.48a.75.75 0 0 0 0 1.5H14a.75.75 0 0 0 .75-.75V2a.75.75 0 0 0-.75-.75Zm-.64 4.621v.002h.001m0 0v-.002Z"
  }));
};
LineRotateRight.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ThinX = function ThinX(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.692 2.795a1.051 1.051 0 1 0-1.487-1.487L8 6.513 2.795 1.308a1.052 1.052 0 0 0-1.487 1.487L6.513 8l-5.205 5.205a1.052 1.052 0 1 0 1.487 1.487L8 9.487l5.205 5.205a1.051 1.051 0 1 0 1.487-1.487L9.487 8l5.205-5.205Z"
  }));
};
ThinX.defaultProps = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Tick = function Tick(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 1.33 5.057 10 0 5.098l1.374-1.33 3.684 3.57L12.626 0 14 1.33z"
  }));
};
Tick.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "10"
};
import isNotEmpty from "../../../utils/isNotEmpty";
import throwError from "../../../utils/throwError";
import LoaderAtm from "../../atoms/LoaderAtm";
import TextAtm from "../../atoms/TextAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import PushOrg from "../../organisms/PushOrg";
import RelativeContainerOrg from "../../organisms/RelativeContainerOrg";
import WrapOrg from "../../organisms/WrapOrg";
import Picture from "../../quarks/Picture";
import BundlePromoBox from "../BundlePromoBoxMol";
import TooltipMol from "../TooltipMol";
import { Aside, background, buttonSizeOnSmallOnly, buttonSizeOnMediumUp, Container, Domain, DomainAndLabelWrap, DomainContainer, Main, PriceWrapper, StyledButton, PriceContainer, DomainNameContainer, PriceAndButtonWrapper } from "./DomainSearchResultItemMol.styled";
function DomainSearchResultItemMol(_ref) {
  var domain = _ref.domain,
    price = _ref.price,
    button = _ref.button,
    label = _ref.label,
    images = _ref.images,
    icon = _ref.icon,
    subtext = _ref.subtext,
    subtextTooltip = _ref.subtextTooltip,
    caption = _ref.caption,
    hasSuccess = _ref.hasSuccess,
    hasError = _ref.hasError,
    errorMessage = _ref.errorMessage,
    isDisabled = _ref.isDisabled,
    disabledMessage = _ref.disabledMessage,
    isLoading = _ref.isLoading,
    hasHiddenLoader = _ref.hasHiddenLoader,
    additionalBox = _ref.additionalBox,
    customButton = _ref.customButton,
    hasImagesAndLabelBottomOnMobile = _ref.hasImagesAndLabelBottomOnMobile,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var isSmallOnly = useBreakpoint("small", "medium");
  var isMediumUp = useBreakpoint("medium");
  var hasBundle = Array.isArray(domain);
  var hasBundleEnabled = hasBundle && !hasError && !isDisabled;
  var hasAdditionalBoxEnabled = isNotEmpty(additionalBox) && !hasError && !isDisabled;
  var domainArray = Array.isArray(domain) ? domain : [domain];
  var _ref2 = button !== null && button !== void 0 ? button : {},
    buttonText = _ref2.text,
    buttonTitle = _ref2.title,
    restButtonProps = _objectWithoutProperties(_ref2, _excluded2);
  if (hasError && !errorMessage) {
    throwError('Prop "errorMessage" must be defined along with "hasError"!');
  }
  if (isDisabled && !disabledMessage) {
    throwError('Prop "disabledMessage" must be defined along with "isDisabled"!');
  }
  var buttonTextVisibility;
  var buttonColor;
  var buttonVariant;
  var buttonIcon;
  if (hasSuccess) {
    buttonTextVisibility = isMediumUp;
    buttonColor = "success";
    buttonVariant = "default";
    buttonIcon = Tick;
  } else if (hasError) {
    buttonTextVisibility = false;
    buttonColor = "dark";
    buttonVariant = "text";
    buttonIcon = LineRotateRight;
  } else if (isDisabled) {
    buttonTextVisibility = false;
    buttonColor = "dark";
    buttonVariant = "text";
    buttonIcon = ThinX;
  } else if (isMediumUp && hasBundle) {
    buttonTextVisibility = isMediumUp;
    buttonColor = "success";
    buttonVariant = "default";
    buttonIcon = undefined;
  } else {
    buttonTextVisibility = isMediumUp;
    buttonColor = "dark";
    buttonVariant = "outlined";
    buttonIcon = isSmallOnly ? CartAdd : undefined;
  }
  var labelAndImageJsx = (label || images || icon) && /*#__PURE__*/React.createElement(WrapOrg, {
    gutterSpace: 1,
    alignCenter: "vertical"
  }, label, images ? images.map(function (_ref3) {
    var imageTooltip = _ref3.tooltip,
      restImageProps = _objectWithoutProperties(_ref3, _excluded3);
    return /*#__PURE__*/React.createElement(RelativeContainerOrg, {
      key: restImageProps.src
    }, /*#__PURE__*/React.createElement(Picture, {
      srcData: restImageProps
    }), imageTooltip ? /*#__PURE__*/React.createElement(TooltipMol, {
      isOverlappingRelativeContainer: true
    }, imageTooltip) : null);
  }) : null, icon);
  var domainJsx = /*#__PURE__*/React.createElement(DomainContainer, null, domainArray.map(function (domainElement) {
    if (/*#__PURE__*/isValidElement(domainElement)) {
      return domainElement;
    }
    var _ref4 = domainElement,
      name = _ref4.name,
      extension = _ref4.extension,
      extensionColor = _ref4.extensionColor,
      domainTooltip = _ref4.tooltip;
    var successColor = !hasError && !isDisabled ? "success" : undefined;
    return /*#__PURE__*/React.createElement(Domain, {
      typography: "medium2_s",
      emphasis: isDisabled ? "medium" : undefined,
      key: name + extension
    }, /*#__PURE__*/React.createElement("span", null, name), /*#__PURE__*/React.createElement(TextAtm, {
      color: extensionColor || successColor,
      emphasis: hasError || isDisabled ? "medium" : undefined,
      isBold: true
    }, extension), domainTooltip);
  }));
  var priceJsx = price ? /*#__PURE__*/React.createElement(PriceWrapper, null, errorMessage || disabledMessage ? /*#__PURE__*/React.createElement(TextAtm, {
    typography: "nano2_u"
  }, errorMessage || disabledMessage) : /*#__PURE__*/React.createElement(PriceContainer, null, price)) : null;
  var buttonJsx = button && buttonTitle ? /*#__PURE__*/React.createElement(StyledButton, _extends({
    title: buttonTitle,
    color: buttonColor,
    variant: buttonVariant,
    size: isSmallOnly ? buttonSizeOnSmallOnly : buttonSizeOnMediumUp,
    icon: buttonIcon,
    isDisabled: isDisabled,
    isWider: true
  }, restButtonProps), buttonTextVisibility ? buttonText : null) : null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Container, _extends({
    $hasBundle: hasBundle
  }, restProps), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: background
  }, /*#__PURE__*/React.createElement(Main, {
    $hasBundle: hasBundle
  }, /*#__PURE__*/React.createElement(DomainNameContainer, null, caption ? /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: 1.5
  }, caption) : null, /*#__PURE__*/React.createElement(DomainAndLabelWrap, {
    $hasImagesAndLabelBottomOnMobile: hasImagesAndLabelBottomOnMobile,
    gutterSpace: {
      x: 3,
      y: 0.5
    },
    alignCenter: !hasImagesAndLabelBottomOnMobile ? "vertical" : undefined
  }, domainJsx, /*#__PURE__*/React.createElement("div", null, labelAndImageJsx)), subtext ? /*#__PURE__*/React.createElement(PushOrg, {
    topSpace: 0.5
  }, subtextTooltip ? /*#__PURE__*/React.createElement(TooltipMol, {
    labelText: subtext,
    labelTypography: "tiny1",
    iconSize: "small"
  }, subtextTooltip) : /*#__PURE__*/React.createElement(TextAtm, {
    typography: "tiny1",
    emphasis: "medium"
  }, subtext)) : null), hasAdditionalBoxEnabled ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 2,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(BundlePromoBox, {
    text: additionalBox.text,
    icon: additionalBox.icon
  }))) : null, hasBundle && priceJsx ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, priceJsx) : priceJsx), /*#__PURE__*/React.createElement(PriceAndButtonWrapper, {
    direction: hasBundleEnabled ? "column" : "row",
    alignItems: hasBundleEnabled ? "flex-end" : "center",
    $hasBundle: hasBundle
  }, hasBundle && priceJsx ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(PushOrg, {
    bottomSpace: !hasError && !isDisabled ? 2 : undefined,
    hasNoReset: true
  }, priceJsx)) : null, /*#__PURE__*/React.createElement(Aside, {
    $hasError: !!hasError || !!isDisabled
  }, isLoading ? !hasHiddenLoader && /*#__PURE__*/React.createElement(LoaderAtm, {
    size: "tiny"
  }) : customButton || buttonJsx)))), hasAdditionalBoxEnabled ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "small",
    to: "medium"
  }, /*#__PURE__*/React.createElement(BundlePromoBox, {
    text: additionalBox.text,
    icon: additionalBox.icon
  })) : null);
}
export default DomainSearchResultItemMol;